import { render, staticRenderFns } from "./contentAbout.vue?vue&type=template&id=bef4e72c&"
import script from "./contentAbout.vue?vue&type=script&lang=js&"
export * from "./contentAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports